import getTrxCode from '@hooks/configuration/getTrxCode';
import getTrxCodeResponse from '@domain/model/response/configuration/getTrxCodeResponse';

const useGetTrxCode = () => {
    const response = getTrxCode();
    const transformedData = getTrxCodeResponse(response.data);

    return {
        ...response,
        data: transformedData,
    };
};

export default useGetTrxCode;
